export const timeService = {
    getTime
}

function getTimeByText(text) {
    const now = new Date();

    if (!text)
        return null;

    let date = null;

    switch(text.toLowerCase()) { 
        case "now": { 
           date = now;
           break; 
        } 
        default: {
            date = text;
            break;
        }
     } 

     return date;
}

function getTime(text) {
    const d = getTimeByText(text);
    
    if (!d || typeof d === "string")
        return d;

    return `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`;
}